import { render } from "./noticeList.vue?vue&type=template&id=5ec5cb08&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"

import "./noticeList.vue?vue&type=style&index=0&id=5ec5cb08&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./noticeList.vue?vue&type=style&index=2&id=5ec5cb08&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec5cb08"]])

export default __exports__